import { Box, SystemIcon, Typography } from '@wishket/design-system';

export const BottomInfo = () => {
  return (
    <Box className="w-full bg-w-gray-10 px-5 py-4 desktop:px-8">
      <Box className="flex flex-col gap-1">
        <Box className="flex items-center gap-1">
          <SystemIcon
            name="small_radio_dot"
            className="size-1 text-w-gray-500"
          />
          <Typography variant="body2" className="text-w-gray-500">
            이미지를 조정하여 필요한 부분만 잘라내세요.
          </Typography>
        </Box>
        <Box className="flex items-center gap-1">
          <SystemIcon
            name="small_radio_dot"
            className="size-1 text-w-gray-500"
          />
          <Typography variant="body2" className="text-w-gray-500">
            1MB 이하의 JPG, JPEG, PNG만 업로드 가능합니다.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
